const { COLORS } = require('../util/Colors');

const STATUS_COLOR = {
  'N/A': '#666',
  Unmapped: COLORS.red,
  Unpaid: COLORS.orange,
  Complete: COLORS.green,
};

const DealMappedStatus = ({ amount, mapped, paid }) => {
  if (!amount || parseFloat(amount) === 0) return 'Unmapped';
  if (
    !mapped ||
    parseFloat(mapped) === 0 ||
    parseFloat(mapped) !== parseFloat(amount)
  )
    return 'Unmapped';
  if (parseFloat(paid) !== parseFloat(amount)) return 'Unpaid';
  return 'Complete';
};

module.exports = {
  DealMappedStatus,
  STATUS_COLOR,
};
